import {z} from 'zod';
import {CommercePaymentProductSchema} from './commerce-types.js';

export const EARNINGS_PATH='/account/earnings';
const amount=z.string().regex(/^-?\d+$/);
const money={product:CommercePaymentProductSchema,currency:z.string(),network:z.string().nullable(),decimals:z.number().int().min(0).max(18)};
export const CommerceEarningsSchema=z.object({
  observedAt:z.iso.datetime(),
  balances:z.array(z.object({...money,sales:z.number().int().nonnegative(),grossAtomic:amount,refundedAtomic:amount,refundDueAtomic:amount,
    taxAtomic:amount,feesAtomic:amount,adjustmentsAtomic:amount,earnedAtomic:amount,paidOutAtomic:amount,unpaidAtomic:amount}).strict()),
  activity:z.array(z.object({...money,id:z.uuid(),orderId:z.uuid(),description:z.string(),createdAt:z.iso.datetime(),
    category:z.enum(['sale','refund','tax','fee','payout','adjustment']),changeAtomic:amount}).strict()),
  hasMore:z.boolean(),
  methods:z.array(z.object({product:CommercePaymentProductSchema,name:z.string(),path:z.string(),collectionEnabled:z.boolean()}).strict()),
}).strict();
export type CommerceEarnings=z.infer<typeof CommerceEarningsSchema>;
